
const digest = '37bf5601e563a8bec9739af12f90c8fdeded20ee44ff710abafdba4c9794bef5';
const classes = {"wrapper":"_wrapper_woulb_1","quickAdjustmentWrapper":"_quickAdjustmentWrapper_woulb_5"};
const css = `._wrapper_woulb_1 {
  display: flex;
}

._quickAdjustmentWrapper_woulb_5 {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  